export const FREE_COMPONENT_ONE = `
<div>
	<div class="foundation-grid content-wrapper foundation-grid app-cont">
		<div class="free-comp-header text-center">
			<h2 class="heading">Investments Made Simple</h2><br>
		</div>
		<div class="text-center mb30">
			<p>By Cleartax, trusted by <span class="paint-bg">25 lakh Indians</span> for their financial needs</p><br>
		</div>
		<div class="row save-home-btns">
			<div class="large-5 large-offset-1 medium-5 medium-offset-1 small-12 columns">
				<div class="content-box">
					<h4>Invest in Tax Saving Funds</h4><button onClick={showTaxPlan} class="btn1 clrsave-btn btn-shine full-width" type="button">Start tax savings</button>
					<ul>
						<li>
							<div class="tick-wrapper">
								<img alt="tick" src="https://assets1.cleartax-cdn.com/clearsave/images/block_tick.svg">
								<p class="tick-wrapper-p">Lowest Lock-in of 3 years</p>
							</div>
						</li>
						<li>
							<div class="tick-wrapper">
								<img alt="tick" src="https://assets1.cleartax-cdn.com/clearsave/images/block_tick.svg">
								<p class="tick-wrapper-p">Upto 2x higher returns</p>
							</div>
						</li>
						<li>
							<div class="tick-wrapper">
								<img alt="tick" src="https://assets1.cleartax-cdn.com/clearsave/images/block_tick.svg">
								<p class="tick-wrapper-p">Option to invest Monthhly (SIP)</p>
							</div>
						</li>
					</ul>
				</div>
			</div>
			<div class="large-6 medium-6 small-12 columns">
				<div class="content-box">
					<h4>Invest in Mutual Funds</h4><button onClick={showGrowthPlans} class="btn2 clrsave-btn btn-shine full-width" type="button">Grow your money</button>
					<ul>
						<li>
							<div class="tick-wrapper">
								<img alt="tick" src="https://assets1.cleartax-cdn.com/clearsave/images/block_tick.svg">
								<p class="tick-wrapper-p">Good returns in last 5 years</p>
							</div>
						</li>
						<li>
							<div class="tick-wrapper">
								<img alt="tick" src="https://assets1.cleartax-cdn.com/clearsave/images/block_tick.svg">
								<p class="tick-wrapper-p">2x higher interest rates than FD/PPF</p>
							</div>
						</li>
						<li>
							<div class="tick-wrapper">
								<img alt="tick" src="https://assets1.cleartax-cdn.com/clearsave/images/block_tick.svg">
								<p class="tick-wrapper-p">Option to invest Monthly (SIP)</p>
							</div>
						</li>
					</ul>
				</div>
			</div>
		</div>
		<div></div>
	</div>
</div>
  <style>
.content-box{
        max-width: 300px;
        margin:auto;
}
.free-comp-header {
   padding-top:30px;
}

.save-home-btns h4 {
    font-size: 24px;
}

.tick-wrapper{
    padding: 10px 0;
    line-height: 16px;
    text-align: left;
    margin-left: 0px;

}
.tick-wrapper-p{
    margin-left:15px;
    padding-left: 10px;
}
.tick-wrapper img {
    float: left;
    width: 18px;
    padding: left;
}
.save-home-btns .text{
    max-width: 30.7rem;
}

.save-home-btns .btn1 {
    max-width: 18.4rem;
    margin-top: 1em;
    margin-bottom: 1em;
    background:#ff7226;
}
.save-home-btns .btn2 {
    max-width: 18.4rem;
    margin-top: 1em;
    margin-bottom: 1em;
    background:#16d916;
}
.paint-bg{
    background: url("https://assets1.cleartax-cdn.com/clearsave/images/highlight.svg");
    background-repeat: no-repeat;
    background-position: 0;
    background-position-x: 0px;
    background-position-y: center;
    background-size: contain;
    font-weight: 700;
    padding: 0 5px;
    display: inline-block;
    font-size: 20px;
}
@media screen and (max-width:414px){
    .content-box{
        float: none;

    }
    .image{
        height: 103px;
    }
    .image1{
        height: 103px;
        padding-left: 50px;
    }

    .custom-margin {
        margin-top: 21px;
        padding-top: 2px;
    }
}
@media screen and (min-width: 1024px){
    .content-box{
        max-width: 76%;
        width:100%;
        margin:auto;
        padding-right: 20px;
    }
}

}
@media screen and (min-width: 768px){
    .content-box-right{
        max-width: none;
        padding:12px;
    }
}
</style>
</div>
`;

export const FREE_COMPONENT_TWO = `
<div>
    <div class="row save-home-btns free-comp-section">
      <div class="large-5 medium-6 small-12 columns mt20 custom-margin">
        <div class="content-box-left">
          <img src="https://assets1.cleartax-cdn.com/clearsave/images/piggy_three.svg" alt="Start invest with as low as 500" class="image" />
        </div>
      </div>
      <div class="large-7 medium-6 small-12 columns">
        <div class="content-text">
          <h4 class="section1">Start Investing with as low as 500</h4>
					<a href="/save/plan/21" class="section1-p">Invest in a Rs.500 plan <span class="arrow">&#8594;</span></a>
        </div>
      </div>
    </div>
  	<div style="display:none;" class="row save-home-btns">
      <div class="large-5 medium-6 small-12 columns" style="float: right" >
          <div class="content-box">
              <img src="https://assets1.cleartax-cdn.com/clearsave/images/tvman.svg" alt="Withdraw and Invest Anytime online" class="image1" align="left" />
          </div>
      </div>
      <div class="large-7 medium-6 small-12 columns">
      	<div class="content-box-right">
          <h4 class="section2">Withdraw and Invest Anytime online</h4>
        </div>
      </div>
  	</div>
  <style>
.content-box{
  max-width: 300px;
  margin:auto;
}
.content-box-left{
    max-width: 43%;
    width:100%;
    margin:auto;
}
.content-box-right{
    max-width: 70px;
    padding: 10px;
}
.content-text {
    padding-top: 40px;
    max-width: 700px;
    margin: auto;
    padding-right: 60px;

}
.free-comp-header {
   padding-top:30px;
}

.tick-wrapper{
    padding: 10px 0;
    line-height: 16px;
    text-align: left;
    margin-left: 0px;

}
.tick-wrapper-p{
    margin-left:15px;
    padding-left: 10px;
}
.tick-wrapper img {
    float: left;
    width: 18px;
    padding: left;
}
.save-home-btns .text{
    max-width: 30.7rem;
}
.save-home-btns .section{
    margin: 0 auto;
    max-width: 34.5rem;
    width: 100%;
}

.save-home-btns .btn1 {
    max-width: 18.4rem;
    margin-top: 1em;
    margin-bottom: 1em;
    background:#ff7226;
}
.save-home-btns .btn2 {
    max-width: 18.4rem;
    margin-top: 1em;
    margin-bottom: 1em;
    background:#16d916;
}
.paint-bg{
    background: url("https://assets1.cleartax-cdn.com/clearsave/images/highlight.svg");
    background-repeat: no-repeat;
    background-position: 0;
    background-position-x: 0px;
    background-position-y: center;
    background-size: contain;
    font-weight: 700;
    padding: 0 5px;
    display: inline-block;
    font-size: 20px;
}
.section1{
    margin-top: 10px;
    font-size: 30px;
    padding: 10px;
}
.section1-p {
    color : #6ccbfd;
    font-size: 20px;
    padding: 10px;
		font-weight: 600;
		cursor: pointer;
}

.section1-p:hover {
	text-decoration: underline;
}
.section2-p{
    color : #6ccbfd;
    font-size: 20px;
    padding: 10px;
    padding-left:18%;
    text-align: left;
}
.section2{
    margin-top: 10px;
    font-size: 30px;
    padding-left:18%;
    text-align: left;
}
.content-box-right{
    padding-top: 40px;
    max-width: 700px;
    margin: auto;
    padding-right: 20px;

}
@media screen and (max-width:414px){
    .content-text{
        padding-top: 3px;
        max-width: 1000px;
        margin: auto;
        padding-left: 46px;
        float: none;
    }
    .content-box-right{
        padding-top: 3px;
        max-width: 1000px;
        padding-left: 41px;
        float: none;
    }
    .content-box-left{
        width: 100%;
    }
    .content-box{
        float: none;

    }
    .image{
        height: 103px;
    }
    .image1{
        height: 103px;
        padding-left: 50px;
    }
    .section1{
        font-size: 15px;
        padding: 5px;
    }
    .section2{
        font-size: 15px;
        padding: 5px;
        text-align: left;
    }
    .section1-p{
        font-size: 12px;
        padding: 5px;
    }
    .section2-p{
        font-size: 12px;
        padding: 5px;
        text-align: left;
    }
    .custom-margin {
        margin-top: 21px;
        padding-top: 2px;
    }
}
@media screen and (min-width: 1024px){
    .content-box{
        max-width: 76%;
        width:100%;
        margin:auto;
        padding-right: 20px;
    }
    .content-text{
        padding-top: 20px;
        max-width: 700px;
        margin: auto;
        padding-right: 20px;

    }
}

}
@media screen and (min-width: 768px){
    .content-box-right{
        max-width: none;
        padding:12px;
    }
}
</style>
</div>
`;

export const FREE_COMPONENT_THREE = `
<div>
    <div style="display:none;" class="row save-home-btns">
      <div class="large-5 medium-6 small-12 columns mb20 custom-margin">
        <div class="content-box-left">
          <img src="https://assets1.cleartax-cdn.com/clearsave/images/piggy_three.svg" alt="Start invest with as low as 500" class="image" />
        </div>
      </div>
      <div class="large-7 medium-6 small-12 columns">
        <div class="content-text">
          <h4 class="section1">Start Investing with as low as 500</h4>
        </div>
      </div>
    </div>
  	<div class="row save-home-btns">
      <div class="large-5 medium-6 small-12 columns" style="float: right" >
          <div class="content-box">
              <img src="https://assets1.cleartax-cdn.com/clearsave/images/tvman.svg" alt="Withdraw and Invest Anytime online" class="image1" align="left" />
          </div>
      </div>
      <div class="large-7 medium-6 small-12 columns">
      	<div class="content-box-right">
          <h4 class="section2">Handpicked funds by Financial Experts</h4>
        </div>
      </div>
  	</div>
  <style>
.content-box{
        max-width: 300px;
        margin:auto;
}
.content-box-left{
    max-width: 43%;
    width:100%;
    margin:auto;
}
.content-box-right{
    max-width: 70px;
    padding: 10px;
}
.content-text{
    padding-top: 40px;
    max-width: 700px;
    margin: auto;
    padding-right: 60px;

}
.free-comp-header {
   padding-top:30px;
}

.tick-wrapper{
    padding: 10px 0;
    line-height: 16px;
    text-align: left;
    margin-left: 0px;

}
.tick-wrapper-p{
    margin-left:15px;
    padding-left: 10px;
}
.tick-wrapper img {
    float: left;
    width: 18px;
    padding: left;
}
.save-home-btns .text{
    max-width: 30.7rem;
}
.save-home-btns .section{
    margin: 0 auto;
    max-width: 34.5rem;
    width: 100%;
}

.save-home-btns .btn1 {
    max-width: 18.4rem;
    margin-top: 1em;
    margin-bottom: 1em;
    background:#ff7226;
}
.save-home-btns .btn2 {
    max-width: 18.4rem;
    margin-top: 1em;
    margin-bottom: 1em;
    background:#16d916;
}
.paint-bg{
    background: url("https://assets1.cleartax-cdn.com/clearsave/images/highlight.svg");
    background-repeat: no-repeat;
    background-position: 0;
    background-position-x: 0px;
    background-position-y: center;
    background-size: contain;
    font-weight: 700;
    padding: 0 5px;
    display: inline-block;
    font-size: 20px;
}
.section1{
    margin-top: 10px;
    font-size: 30px;
    padding: 10px;
}
.section1-p{
    color : #6ccbfd;
    font-size: 20px;
    padding: 10px;
}
.section2-p{
    color : #6ccbfd;
    font-size: 20px;
    padding: 10px;
    padding-left:18%;
    text-align: left;
}
.section2{
    margin-top: 10px;
    font-size: 30px;
    padding-left:18%;
    text-align: left;
}
.content-box-right{
    padding-top: 40px;
    max-width: 700px;
    margin: auto;
    padding-right: 20px;

}
@media screen and (max-width:414px){
    .content-text{
        padding-top: 3px;
        max-width: 1000px;
        margin: auto;
        padding-left: 46px;
        float: none;
    }
    .content-box-right{
        padding-top: 3px;
        max-width: 1000px;
        padding-left: 41px;
        float: none;
    }
    .content-box-left{
        width: 100%;
    }
    .content-box{
        float: none;

    }
    .image{
        height: 103px;
    }
    .image1{
        height: 103px;
        padding-left: 50px;
    }
    .section1{
        font-size: 15px;
        padding: 5px;
    }
    .section2{
        font-size: 15px;
        padding: 5px;
        text-align: left;
    }
    .section1-p{
        font-size: 12px;
        padding: 5px;
    }
    .section2-p{
        font-size: 12px;
        padding: 5px;
        text-align: left;
    }
    .custom-margin {
        margin-top: 21px;
        padding-top: 2px;
    }
}
@media screen and (min-width: 1024px){
    .content-box{
        max-width: 76%;
        width:100%;
        margin:auto;
        padding-right: 20px;
    }
    .content-text{
        padding-top: 20px;
        max-width: 700px;
        margin: auto;
        padding-right: 20px;

    }
}

}
@media screen and (min-width: 768px){
    .content-box-right{
        max-width: none;
        padding:12px;
    }
}
</style>
</div>
`;



// WEBPACK FOOTER //
// ./constants/freeComponentData.ts